import { render, staticRenderFns } from "./CountryList.vue?vue&type=template&id=1ba2f3d6&"
import script from "./CountryList.vue?vue&type=script&lang=ts&"
export * from "./CountryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ba2f3d6')) {
      api.createRecord('1ba2f3d6', component.options)
    } else {
      api.reload('1ba2f3d6', component.options)
    }
    module.hot.accept("./CountryList.vue?vue&type=template&id=1ba2f3d6&", function () {
      api.rerender('1ba2f3d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/countries/CountryList.vue"
export default component.exports